// ===== Every new page opens at the top, and only the visitor moves it =====
// 1) Fresh navigations (not back/forward, no #anchor) are pinned to the top
//    while the page settles, unless the visitor has already touched/scrolled.
// 2) Afterwards, a scroll jump that is caused by a script grabbing focus
//    (popups, widgets) with no visitor input is undone. Visitor-initiated
//    scrolling - including our own buttons that scroll after a tap - is never
//    touched.
(function () {
  var lastUser = 0;
  var lastFocus = 0;
  var lastScrollT = 0;
  var lastY = window.scrollY || 0;
  ['touchstart', 'touchmove', 'wheel', 'keydown', 'mousedown', 'pointerdown'].forEach(function (ev) {
    window.addEventListener(ev, function () { lastUser = Date.now(); }, { passive: true, capture: true });
  });
  document.addEventListener('focusin', function () { lastFocus = Date.now(); }, true);

  // --- 1) land at the top ---
  var navEntry = (window.performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation')[0] : null;
  var isBackForward = navEntry && navEntry.type === 'back_forward';
  var pinned = !isBackForward && !window.location.hash;
  function toTop() {
    if (pinned && !lastUser && (window.scrollY || 0) > 0) window.scrollTo(0, 0);
  }
  if (pinned) {
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    toTop();
    document.addEventListener('DOMContentLoaded', toTop);
    window.addEventListener('pageshow', function (e) { if (!e.persisted) toTop(); });
    window.addEventListener('load', function () {
      toTop();
      [150, 400, 900, 1600, 2500].forEach(function (ms) { setTimeout(toTop, ms); });
      setTimeout(function () {
        pinned = false;
        try { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; } catch (e) {}
      }, 2600);
    });
  }

  // --- 2) undo focus-induced jumps ---
  window.addEventListener('scroll', function () {
    var now = Date.now();
    var y = window.scrollY || 0;
    if (pinned && !lastUser && y > 0) { window.scrollTo(0, 0); return; }
    var userRecent = now - lastUser < 1500;
    var focusRecent = now - lastFocus < 500;
    var continuation = now - lastScrollT < 150;
    if (!userRecent && focusRecent && !continuation && Math.abs(y - lastY) > 200) {
      window.scrollTo(0, lastY);
      return;
    }
    lastY = y;
    lastScrollT = now;
  }, { passive: true });
})();

document.addEventListener("DOMContentLoaded", function () {

  // Trust-features footer button pointing at the page you are already on:
  // smooth scroll to the top instead of reloading (other pages open at the
  // top via the guard above).
  document.querySelectorAll('.trust-features-section .dev-btn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      try {
        const url = new URL(btn.href, window.location.href);
        if (url.pathname === window.location.pathname && url.search === window.location.search) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } catch (err) { /* fall through to the normal navigation */ }
    });
  });

  // Close button
  document.querySelectorAll('.pdp-cro-size-chart-close').forEach(btn => {
    btn.addEventListener('click', function (event) {
        event.preventDefault();
      document.body.classList.remove('pdp-cro-size-chart-open');
    });
  });

  // Open button
  document.querySelectorAll('.size-chart-main-part').forEach(btn => {
    btn.addEventListener('click', function (event) {
        event.preventDefault();
      document.body.classList.add('pdp-cro-size-chart-open');
    });
  });


  // Product tab click handler
  document.addEventListener('click', function (e) {

    const link = e.target.closest('.product-tab-list a');
    if (!link) return;

    // Prevent default only for tab links
    e.preventDefault();

    const productTab = link.closest('.product-tab');
    if (!productTab) return;

    const hrefId = link.getAttribute('href');

    productTab.querySelectorAll('a').forEach(a => a.classList.remove('active'));
    productTab.querySelectorAll('.tab-panal').forEach(panel => panel.classList.remove('active'));

    link.classList.add('active');

    const targetPanel = document.querySelector(hrefId);
    if (targetPanel) targetPanel.classList.add('active');
  });

  // Product-card image carousel: one slide per image of the card color, moved by CSS transform, driven by
  // a touch flick (same mechanism as the PDP gallery) or a click on the dots.
  // Disabled inside featured-collection sliders, where swiping moves between
  // products instead.
  document.querySelectorAll('[data-mob-scroller]').forEach(scroller => {
    if (scroller.closest('.featured-collection')) return;
    const card = scroller.closest('.product-card__image');
    if (!card) return;
    const getSlides = () => scroller.querySelectorAll('.product-card__mob-slide');
    const getDots = () => card.querySelectorAll('.product-card__mob-dots .dot');
    const hasColorMap = !!card.parentNode.querySelector('[data-card-color-map]') || !!card.querySelector('[data-card-color-map]');
    if (getSlides().length < 2 && !hasColorMap) return;

    let idx = 0;
    function go(i) {
      // wrap around: past the last image returns to the first (and back)
      const total = getSlides().length;
      idx = total ? ((i % total) + total) % total : 0;
      scroller.style.setProperty('--rv-card-slide', idx);
      getDots().forEach((d, n) => d.classList.toggle('active', n === idx));
    }

    let startX = null, startY = null, startT = 0;
    scroller.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = Date.now();
    }, { passive: true });
    scroller.addEventListener('touchcancel', function () { startX = null; }, { passive: true });
    scroller.addEventListener('touchend', function (e) {
      if (startX === null) return;
      const t = e.changedTouches && e.changedTouches[0];
      const sx = startX; startX = null;
      if (!t) return;
      const dx = t.clientX - sx;
      const dy = t.clientY - startY;
      if (Math.abs(dy) > Math.abs(dx)) return; // vertical scroll — leave it alone
      const velocity = Math.abs(dx) / Math.max(Date.now() - startT, 1);
      if (Math.abs(dx) < 25 && velocity < 0.35) return; // not a deliberate swipe
      go(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    card.addEventListener('click', function (e) {
      const d = e.target.closest('.product-card__mob-dots .dot');
      if (!d || !card.contains(d)) return;
      e.preventDefault();
      e.stopPropagation();
      go(Array.prototype.indexOf.call(getDots(), d));
    });

    // Rebuild the extra slides + dots from another color's image list.
    function setExtraImages(urls, href) {
      scroller.querySelectorAll('.product-card__mob-slide--extra').forEach(el => el.remove());
      (urls || []).forEach(u => {
        const a = document.createElement('a');
        a.className = 'product-card__mob-slide product-card__mob-slide--extra product-card__mob-slide--js';
        a.href = href;
        a.tabIndex = -1;
        a.setAttribute('aria-hidden', 'true');
        const im = document.createElement('img');
        im.src = u;
        im.alt = '';
        im.loading = 'lazy';
        im.draggable = false;
        a.appendChild(im);
        scroller.appendChild(a);
      });
      let wrap = card.querySelector('.product-card__mob-dots');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'product-card__mob-dots';
        wrap.setAttribute('aria-hidden', 'true');
        scroller.insertAdjacentElement('afterend', wrap);
      }
      wrap.innerHTML = '';
      const total = getSlides().length;
      wrap.style.display = total > 1 ? '' : 'none';
      for (let n = 0; n < total; n++) {
        const sp = document.createElement('span');
        sp.className = 'dot' + (n === 0 ? ' active' : '');
        wrap.appendChild(sp);
      }
    }

    // Color swatches: picking a color resets the carousel to that color's
    // first image, points slide 2 at the image that follows it in the
    // gallery, and deep-links the card's links so the product page opens
    // with that color preselected (?color=...).
    const cardRoot = scroller.closest('.product-card');
    const mapEl = cardRoot ? cardRoot.querySelector('[data-card-color-map]') : null;
    if (cardRoot && mapEl) {
      let colorMap = {};
      try { colorMap = JSON.parse(mapEl.textContent); } catch (err) { colorMap = {}; }
      cardRoot.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-swatch-button]');
        if (!btn || !cardRoot.contains(btn)) return;
        const entry = colorMap[(btn.dataset.color || '').toLowerCase()];
        if (!entry) return;
        const qs = '?color=' + encodeURIComponent(entry.label);
        const baseLink = cardRoot.querySelector('a.product-card__mob-slide');
        setExtraImages(entry.imgs, (baseLink ? baseLink.href.split('?')[0] : '#') + qs);
        go(0);
        if (entry.img2) {
          const im = cardRoot.querySelector('.product-card__image-secondary img');
          if (im) {
            im.srcset = '';
            im.removeAttribute('data-rimg');
            im.src = entry.img2;
          }
        }
        cardRoot.querySelectorAll('a.product-card__mob-slide, a.product-card__link, a.product-card__image-link').forEach(a => {
          a.href = a.href.split('?')[0] + qs;
        });
      });
    }
  });

   // Listen to all elements having data-add-btn
  document.querySelectorAll('[data-add-btn]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      // Target CTA button
      const ctaBtn = document.querySelector('.buy-buttons__buttons .button-action');
      if (!ctaBtn) return;

      // Smooth scroll into view
      ctaBtn.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Trigger click after scrolling with small delay
      setTimeout(() => {
        ctaBtn.click();
      }, 400); // delay so scroll finishes smoothly
    });
  });


});

/* ===== Shop the look hotspots (collection grid, snippets/rv-shop-the-look.liquid) =====
   Tap a dot -> its bubble opens (any other closes); tap the dot again, anywhere
   outside, or press Escape -> closes. Delegated so theme-editor re-renders work. */
(function () {
  if (window.__rvLookInit) return;
  window.__rvLookInit = true;
  function closeAll(except) {
    document.querySelectorAll('.rv-look__hotspot.is-open').forEach(function (s) {
      if (s === except) return;
      s.classList.remove('is-open');
      var d = s.querySelector('[data-rv-look-dot]');
      if (d) d.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-rv-look-dot]');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      var spot = dot.closest('.rv-look__hotspot');
      var open = spot.classList.contains('is-open');
      closeAll(spot);
      spot.classList.toggle('is-open', !open);
      dot.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    if (e.target.closest('.rv-look__bubble')) return;
    closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

/* ===== Shop the look: theme-editor drag helper =====
   Only inside the Shopify theme editor (Shopify.designMode). Drag a dot on the
   preview image; a label shows "Left X% / Top Y%" and stays after release so
   the values can be typed into the block's two sliders. Nothing on the live site. */
(function () {
  if (!(window.Shopify && window.Shopify.designMode)) return;
  if (window.__rvLookDragInit) return;
  window.__rvLookDragInit = true;
  document.documentElement.classList.add('rv-look-design');
  var drag = null, suppressClick = false;
  function setLabel(spot, x, y) {
    var l = spot.querySelector('.rv-look__pos');
    if (!l) {
      l = document.createElement('span');
      l.className = 'rv-look__pos';
      spot.appendChild(l);
    }
    l.textContent = 'Left ' + x + '%  ·  Top ' + y + '%';
  }
  document.addEventListener('pointerdown', function (e) {
    var spot = e.target.closest('.rv-look__hotspot');
    if (!spot || e.target.closest('.rv-look__bubble')) return;
    var img = spot.closest('.rv-look__image');
    if (!img) return;
    e.preventDefault();
    // capture on the dot button itself: a captured pointer retargets the click to the
    // capturing element, and the bubble toggle looks for the button
    var cap = e.target.closest('[data-rv-look-dot]') || spot;
    drag = { spot: spot, cap: cap, img: img, moved: false, sx: e.clientX, sy: e.clientY, id: e.pointerId };
    try { cap.setPointerCapture(e.pointerId); } catch (err) {}
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    if (!drag.moved && Math.hypot(e.clientX - drag.sx, e.clientY - drag.sy) < 3) return;
    drag.moved = true;
    drag.spot.classList.remove('is-open');
    drag.spot.classList.add('rv-look__hotspot--dragged');
    var r = drag.img.getBoundingClientRect();
    var x = Math.round(Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100)));
    var y = Math.round(Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100)));
    drag.spot.style.left = x + '%';
    drag.spot.style.top = y + '%';
    setLabel(drag.spot, x, y);
  });
  function end(e) {
    if (!drag || (e.pointerId !== undefined && e.pointerId !== drag.id)) return;
    try { drag.cap.releasePointerCapture(drag.id); } catch (err) {}
    if (drag.moved) {
      // the click that follows a drag fires in the same task; clear the flag right after
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 0);
    }
    drag = null;
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  // a drag ends with a click on the dot: swallow it so the bubble doesn't toggle
  document.addEventListener('click', function (e) {
    if (!suppressClick) return;
    suppressClick = false;
    if (e.target.closest('.rv-look__hotspot')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();


/* ===== Layout debug overlay (only with ?rvdebug=1 in the URL) =====
   Lists elements that stick out past the right edge of the screen, with the
   viewport numbers, so phone-only overflow can be diagnosed from a screenshot.
   Inert on every normal page view. */
(function () {
  if (!/[?&]rvdebug=1/.test(location.search)) return;
  function sel(el) {
    var c = typeof el.className === 'string' ? el.className.trim().split(/\s+/).slice(0, 3).join('.') : '';
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id.slice(0, 20) : '') + (c ? '.' + c : '');
  }
  function clippedBy(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      var o = getComputedStyle(p).overflowX;
      if (o !== 'visible') return sel(p);
      p = p.parentElement;
    }
    return '';
  }
  function run() {
    var vw = document.documentElement.clientWidth;
    var rows = [];
    document.querySelectorAll('body *').forEach(function (el) {
      if (el.id === 'rv-debug-overlay') return;
      var r = el.getBoundingClientRect();
      if (r.width < 1 || r.height < 2 || r.left < -3000) return;
      var cs = getComputedStyle(el);
      if (r.right > vw + 1 && !clippedBy(el)) {
        rows.push(Math.round(r.left) + '..' + Math.round(r.right) + ' ' + cs.position + ' ' + sel(el));
      }
    });
    var vv = window.visualViewport;
    var lines = [
      'screen ' + screen.width + 'x' + screen.height + '  inner ' + window.innerWidth + '  client ' + vw,
      'docScrollW ' + document.documentElement.scrollWidth + '  bodyScrollW ' + document.body.scrollWidth + '  scrollX ' + Math.round(window.scrollX),
      vv ? 'visual w ' + Math.round(vv.width) + ' scale ' + vv.scale.toFixed(3) + ' offX ' + Math.round(vv.offsetLeft) : 'no visualViewport',
      'past right edge (' + rows.length + '):'
    ].concat(rows.slice(0, 14));
    var box = document.getElementById('rv-debug-overlay');
    if (!box) {
      box = document.createElement('pre');
      box.id = 'rv-debug-overlay';
      box.style.cssText = 'position:fixed;left:0;top:0;z-index:2147483647;max-width:100%;box-sizing:border-box;margin:0;padding:8px;background:rgba(0,0,0,.92);color:#0f0;font:11px/1.35 monospace;white-space:pre-wrap;word-break:break-all;pointer-events:none;';
      document.body.appendChild(box);
    }
    box.textContent = lines.join('\n');
  }
  window.addEventListener('load', function () { setTimeout(run, 1500); setTimeout(run, 5000); });
  window.addEventListener('scroll', function () { clearTimeout(run._t); run._t = setTimeout(run, 400); }, { passive: true });
})();
